// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/notebook-pen.js';

import { paths } from '../generated/notebook-pen';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('notebook-pen', Original, paths);
